<template lang="">
  <div class="skipModal">
    <el-dialog
      title="提示"
      center
      :visible.sync="skipModalVisible"
      width="330px"
      :before-close="handleClose">
      <span class="skipText">使用该功能需要完善个人信息</span>
      <span slot="footer" class="dialog-footer">
        <el-button class="add_school_close" @click="handleClose">取消</el-button>
        <el-button class="add_school_submit" type="primary" @click="handleSumit">去完善</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
    }
  },
  computed: {
    ...mapState(['user']),
    skipModalVisible() {
      return this.$store.state.skipModalVisible
    }
  },
  methods: {
    handleSumit() {
      this.$store.commit('SET_SKIP_MODAL', false)
      this.$router.push({ name: 'completeMsg' })
    },
    handleClose(done) {
      this.$store.commit('SET_SKIP_MODAL', false)
    }
  }
}
</script>
<style lang="scss" scoped>
  .skipModal {
    /deep/ .el-dialog {
      height: 250px;
      border-radius: 18px;
    }
    .skipText {
      display: block;
      margin-bottom: 30px;
      margin-top: 10px;
      text-align: center;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 28px;
    }
    .add_school_submit {
      width: 88px;
      height: 32px;
      background-color: #FFA21C;
      border: 1px solid #ffa21c;
      color: #fff;
      border-radius: 4px;
      &:hover {
        opacity: 0.7;
      }
    }
    .add_school_close {
      width: 88px;
      height: 32px;
    }
  }
</style>
